<style scoped>
#modalBackdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  position: relative;
  background-color: #fff;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  border: 15px solid rgb(102, 102, 102);
  margin-bottom: 4em;
  margin-top: 4em;
  padding: 2em;
  white-space: normal !important;
  max-height: 95%;
}

.modalContent {
  background-color: #fefefe;
  margin: 1% auto;
  padding: 1.4em;
  border: 1px solid #888;
  width: 80em;
  text-align: center;
  font-size: 90%;
}
.modalContentNarrow {
  background-color: #fefefe;
  margin: 1% auto;
  padding: 1.4em;
  width: 34em;
  overflow: auto;
  height: 100%;
  position: relative;
}
.modalInputWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding-top: 1em;
  padding-bottom: 1em;
}

.modalInputWrapper > label {
  display: inline;
  padding: 1em;
}
</style>

<template>
  <div id="modalBackdrop" @click.self="close">
    <div class="modal">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closeDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    close() {
      if (!this.closeDisabled) {
        this.$emit('close');
      }
    },
    disableClose() {
      this.closeDisabled = true;
    }
  },
};
</script>
